import { defineComponent as b, ref as p, onMounted as f, markRaw as M, h as w, nextTick as O } from "vue";
import h from "leaflet";
import "leaflet.gridlayer.googlemutant";
import { Loader as G } from "@googlemaps/js-api-loader";
import { Functions as j, Utilities as i, InjectionKeys as I } from "@vue-leaflet/vue-leaflet";
const g = {
  options: {
    type: Object,
    default: () => ({}),
    custom: !0
  },
  pane: {
    type: String
  },
  attribution: {
    type: String
  },
  name: {
    type: String,
    custom: !0
  },
  visible: {
    type: Boolean,
    custom: !0,
    default: !0
  },
  opacity: {
    type: Number
  },
  zIndex: {
    type: Number
  },
  tileSize: {
    type: [Number, Array, Object]
  },
  noWrap: {
    type: Boolean,
    default: void 0
  },
  minZoom: {
    type: Number
  },
  maxZoom: {
    type: Number
  },
  className: {
    type: String
  },
  /**
   * Options to pass to Google Maps library loader.
   * https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package
   */
  loaderOptions: {
    type: Object
  },
  /**
   * Google's map type. 'hybrid' is not really supported.
   */
  type: {
    type: String
  },
  /**
   * Google's cloud styling map ID.
   * https://developers.google.com/maps/documentation/cloud-customization/overview#creating_map_styles
   */
  mapId: String
}, S = (o, e, s) => {
  const { options: u, methods: t } = j.GridLayer.setupGridLayer(o, e, s), l = i.propsToLeafletOptions(o, g, u);
  function n() {
    e.value && (e.value._lru.clear(), e.value.redraw());
  }
  return {
    options: l,
    methods: {
      ...t,
      setType(r) {
        var a;
        !((a = e.value) != null && a._mutant) || e.value._mutant.getMapTypeId() === r || (e.value._mutant.setMapTypeId(r), n());
      }
    }
  };
}, E = b({
  name: "LGoogleMutant",
  props: g,
  setup(o, e) {
    const { attrs: s, emit: u } = e, t = p(), l = p(null), n = p(!1), r = i.assertInject(I.AddLayerInjection);
    if (!r)
      throw new Error("LGoogleMutant must be used inside LMap");
    const { options: a, methods: d } = S(o, t, e);
    function m() {
      if (!t.value)
        throw new Error("Failed to initialize GoogleMutant layer");
      r({ ...o, ...d, leafletObject: t.value }), n.value = !0, O(() => u("ready", t.value));
    }
    return f(() => {
      var y, c;
      t.value = M(h.gridLayer.googleMutant(a));
      const { listeners: v } = i.remapEvents(s);
      if ((y = t.value) == null || y.on(v), i.propsBinder(d, t.value, o), (c = window.google) != null && c.maps)
        m();
      else {
        console.debug("Google Maps Library not found. Importing it now.");
        const L = o.loaderOptions || { apiKey: "" };
        new G(L).importLibrary("maps").then(() => m());
      }
    }), {
      root: l,
      ready: n,
      version: "1.3.2"
    };
  },
  render() {
    return this.ready ? w("div", { style: { display: "none" }, ref: "root" }) : null;
  }
});
export {
  E as default,
  g as leafletGoogleMutantLayerProps,
  S as setupLeafletGoogleMutantLayer
};
//# sourceMappingURL=vue-leaflet-googlemutant.es.js.map
